/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LocationDetailsForGcp extends models.LocationDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("LocationDetailsForGcp");
    }

    getFixupPrototypeFunction() { return LocationDetailsForGcp.fixupPrototype; }

    static newInstance(model: Partial<LocationDetailsForGcp>): LocationDetailsForGcp {
        let obj = Object.assign(new LocationDetailsForGcp(), model);
        LocationDetailsForGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LocationDetailsForGcp>): LocationDetailsForGcp {
        if (!model) return null;
        return LocationDetailsForGcp.newInstance(<LocationDetailsForGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LocationDetailsForGcp) {
        if (!obj) return;

        models.LocationDetailsForGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LocationDetailsForGcp): boolean {
        if (models.LocationDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LocationDetailsForGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Full URL reference to the region which hosts the zone.
     */
    region: string;

    /**
     * Server-defined URL for the resource.
     */
    self_link: string;

    /**
     * Status of the zone, either UP or DOWN.
     */
    status: string;

}
